import React from "react";
import { Link } from "react-router-dom";
import SocialLinks from "../ui/SocialLinks";
import "./styles/footer.css";

const NAV_ITEMS = [
	{ path: "/", label: "Home" },
	{ path: "/projects", label: "Projects" },
	{ path: "/research", label: "Research" },
	{ path: "/interests", label: "Interests" },
	{ path: "/experience", label: "Work" },
	{ path: "/contact", label: "Contact" },
];

const Footer = () => {
	return (
		<footer className="footer">
			<div className="footer-inner content-wrapper">
				<div className="footer-links">
					<ul className="footer-nav-link-list">
						{NAV_ITEMS.map((item) => (
							<li key={item.path} className="footer-nav-link-item">
								<Link to={item.path}>{item.label}</Link>
							</li>
						))}
					</ul>
				</div>

				<div className="footer-bottom">
					<p className="footer-credits-text">
						&copy; {new Date().getFullYear()} Bijan Saud. All Rights Reserved.
					</p>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
